import { FC } from 'react';
import RibbleButton from 'v3/common/global/components/RibbleButton';
import { productName } from 'v3/layout/footer/Default/config';

const Calendly: FC = () => {
  return (
    <section className="question">
      <div className="container">
        <h3>Still have Questions?</h3>
        <div className="gradient-line"></div>
        <p>
          Try {productName} Pro free for 7 day, no credit card required. Need something custom? Let’s talk.
        </p>
        <RibbleButton className="green" href="https://wa.me/+918015200788" name="Contact Sales" />
      </div>
    </section>
  );
};

export default Calendly;
